module.exports = __webpack_public_path__ + "assets/arrow.3a84d641.svg";